module.exports = __webpack_public_path__ + "img/1.f6fc2140.png";